'use client';

import { Cms } from '@bytel/product-wall';
import {
    Alignable,
    Button,
    ButtonMarkup,
    ButtonVariant,
    Column,
    Columns,
    Icon,
    IconName,
    IconSize,
    Price,
    PriceLevel,
    StickyPosition,
    Text,
    TextLevels,
    TypographyBold,
} from '@bytel/trilogy-react';

import { HomePackCategory } from '@app-types/home-pack';
import { SimulatedCart } from '@app-types/simulator/virtual-cart';

import { StickyMenu } from 'src/app/(promo-simulator)/_components/sticky-menu';

interface StickyBarProps {
    isVisible: boolean;
    currentSimulatedCart: SimulatedCart;
    currentStaticCategory: HomePackCategory;
    href: string;
    onClick?: () => void;
}

export function StickyBar({
    isVisible,
    currentSimulatedCart,
    currentStaticCategory,
    href,
    onClick,
}: Readonly<StickyBarProps>) {
    const bboxPrice = currentSimulatedCart?.quotes[0]?.products[1]?.details?.price?.final || 0;
    const productPrice = currentSimulatedCart?.quotes[0]?.products[0]?.details?.price?.final || 0;

    return (
        <StickyMenu stickyPosition={StickyPosition.BOTTOM} isVisible={isVisible}>
            <Columns verticalAlign={Alignable.ALIGNED_CENTER} multiline align={Alignable.ALIGNED_CENTER}>
                <Column size={12} widescreenSize={9}>
                    <Columns multiline className='is-spaced-around gap-small' verticalAlign={Alignable.ALIGNED_CENTER}>
                        <Column narrow>
                            <Columns multiline mobile verticalAlign={Alignable.ALIGNED_CENTER}>
                                <Column>
                                    <Columns verticalAlign={Alignable.ALIGNED_CENTER} multiline mobile>
                                        <Column narrow>
                                            <Icon size={IconSize.MEDIUM} name={IconName.BOX} />
                                        </Column>
                                        <Column>
                                            <Text
                                                marginless
                                                typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                                                level={TextLevels.ONE}
                                            >
                                                {`${currentSimulatedCart?.quotes[0]?.products[1]?.name}`}
                                            </Text>
                                        </Column>
                                    </Columns>
                                </Column>
                                {bboxPrice > 0 ? (
                                    <Column narrow>
                                        <Price level={PriceLevel.SIX} amount={bboxPrice} period='mois' />
                                    </Column>
                                ) : null}
                            </Columns>
                        </Column>
                        <Column narrow>
                            <Columns
                                verticalAlign={Alignable.ALIGNED_CENTER}
                                align={Alignable.ALIGNED_CENTER}
                                multiline
                                mobile
                            >
                                <Column>
                                    <Columns
                                        verticalAlign={Alignable.ALIGNED_CENTER}
                                        align={Alignable.ALIGNED_CENTER}
                                        multiline
                                        mobile
                                    >
                                        <Column narrow>
                                            <Icon
                                                size={IconSize.MEDIUM}
                                                name={currentStaticCategory?.icon || IconName.TV_4K}
                                            />
                                        </Column>
                                        <Column>
                                            <Text
                                                marginless
                                                className='has-text-weight-semibold'
                                                level={TextLevels.ONE}
                                            >
                                                <Cms content={currentSimulatedCart?.quotes[0]?.products[0]?.name} />
                                            </Text>
                                        </Column>
                                    </Columns>
                                </Column>
                                {productPrice > 0 ? (
                                    <Column narrow>
                                        <Price
                                            level={PriceLevel.SIX}
                                            amount={currentSimulatedCart.quotes[0]!.products[0]!.details.price.final}
                                        />
                                    </Column>
                                ) : null}
                            </Columns>
                        </Column>
                        <Column narrow>
                            <Button
                                markup={ButtonMarkup.A}
                                href={href}
                                onClick={onClick}
                                variant={ButtonVariant.CONVERSION}
                            >
                                Tester mon éligibilité
                            </Button>
                        </Column>
                    </Columns>
                </Column>
            </Columns>
        </StickyMenu>
    );
}
